module.exports = __webpack_public_path__ + "img/ventas.3bd6e32f.jpeg";